"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WixSDK = exports.createSDK = void 0;
var tslib_1 = require("tslib");
var view_modes_1 = require("@wix/wix-vod-constants/dist/common/view-modes");
var guid_1 = require("./utils/guid");
var lodash_1 = tslib_1.__importDefault(require("lodash"));
function createSDK(WixSDKOriginal) {
    var _this = this;
    var DEFAULT_LOCALE = 'en';
    var AVAILABLE_LOCALES = process.env.AVAILABLE_LOCALES || [DEFAULT_LOCALE];
    var DEVICE_TYPES = {
        MOBILE: 'mobile',
        DESKTOP: 'desktop',
    };
    function invokeSafely(fn, defaultValue) {
        if (defaultValue === void 0) { defaultValue = null; }
        return function () {
            try {
                return fn.apply(this, arguments); // eslint-disable-line no-invalid-this
            }
            catch (ex) {
                return defaultValue;
            }
        };
    }
    function getRandomGuid4() {
        // generate fake guid starting on badabada
        /* eslint-disable */
        return 'badabada-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
            var r = (Math.random() * 16) | 0, v = c == 'x' ? r : (r & 0x3) | 0x8;
            return v.toString(16);
        });
    }
    function setChannelIdToPublicStore(channelId) {
        /* eslint-disable */
        SDK.Data.Public.set('channelId', channelId, { scope: 'COMPONENT' })
            .then(lodash_1.default.partial(console.log, 'Channel id has been saved to Wix public storage'))
            .catch(lodash_1.default.partial(console.warn, 'Can not save channel id to Wix public storage'));
    }
    var newInstance;
    var isBusinessManager = !lodash_1.default.isEmpty(global.BusinessManagerAPI);
    if (WixSDKOriginal && !isBusinessManager) {
        WixSDKOriginal.addEventListener(WixSDKOriginal.Events.INSTANCE_CHANGED, function (event) {
            newInstance = event.instance;
        });
    }
    var SDK = WixSDKOriginal
        ? tslib_1.__assign(tslib_1.__assign({}, WixSDKOriginal), { addEventListener: lodash_1.default.get(WixSDKOriginal, 'addEventListener', lodash_1.default.noop), removeEventListener: WixSDKOriginal.removeEventListener || lodash_1.default.noop, closeWindow: WixSDKOriginal.closeWindow || lodash_1.default.noop, currentMember: function () {
                if (WixSDKOriginal.Utils.getViewMode() === view_modes_1.VIEW_MODES.SITE) {
                    return new Promise(WixSDKOriginal.currentMember);
                }
                return Promise.resolve(null);
            }, getBoundingRectAndOffsets: function () {
                return new Promise(WixSDKOriginal.getBoundingRectAndOffsets);
            }, getSiteUrl: function () {
                var viewMode = WixSDKOriginal.Utils.getViewMode();
                return new Promise(function (resolve) {
                    if (viewMode === view_modes_1.VIEW_MODES.STANDALONE ||
                        viewMode === view_modes_1.VIEW_MODES.DASHBOARD) {
                        return WixSDKOriginal.Dashboard.getSiteViewUrl(function (siteViewUrl) {
                            return resolve(siteViewUrl.base);
                        });
                    }
                    WixSDKOriginal.Settings.getSiteInfo(function (siteInfo) {
                        return resolve(siteInfo.baseUrl);
                    });
                });
            }, getCurrentPageId: function () {
                return new Promise(WixSDKOriginal.getCurrentPageId);
            }, getComponentInfo: function () {
                return new Promise(WixSDKOriginal.getComponentInfo);
            }, Dashboard: tslib_1.__assign(tslib_1.__assign({}, WixSDKOriginal.Dashboard), { getEditorUrl: function () {
                    var getEditorUrl = lodash_1.default.get(WixSDKOriginal, 'Dashboard.getEditorUrl');
                    if (getEditorUrl) {
                        return new Promise(getEditorUrl);
                    }
                    return Promise.resolve(null);
                } }), Data: tslib_1.__assign(tslib_1.__assign({}, WixSDKOriginal.Data), { Public: tslib_1.__assign(tslib_1.__assign({}, lodash_1.default.get(WixSDKOriginal, 'Data.Public', {})), { get: function (key, options) {
                        return new Promise(lodash_1.default.partial(WixSDKOriginal.Data.Public.get, key, options));
                    }, set: function (key, value, options) {
                        return new Promise(lodash_1.default.partial(WixSDKOriginal.Data.Public.set, key, value, options));
                    }, remove: function (key, options) {
                        return new Promise(lodash_1.default.partial(WixSDKOriginal.Data.Public.remove, key, options));
                    }, setChannelIdToPublicData: function (channelId) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                        var e_1;
                        return tslib_1.__generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    _a.trys.push([0, 2, , 3]);
                                    return [4 /*yield*/, this.Data.Public.set('channelId', channelId, {
                                            scope: 'COMPONENT',
                                        })];
                                case 1:
                                    _a.sent();
                                    console.log('Channel id has been saved to Wix public storage');
                                    return [3 /*break*/, 3];
                                case 2:
                                    e_1 = _a.sent();
                                    console.warn('Can not save channel id to Wix public storage', e_1.message);
                                    return [3 /*break*/, 3];
                                case 3: return [2 /*return*/];
                            }
                        });
                    }); }, 
                    /**
                     * @returns {Promise<{channelId: string}>}
                     */
                    getChannelIdFromPublicData: function () {
                        return _this.Data.Public.get('channelId', { scope: 'COMPONENT' });
                    } }) }), PubSub: tslib_1.__assign(tslib_1.__assign({}, WixSDKOriginal.PubSub), { subscribe: lodash_1.default.get(WixSDKOriginal, 'PubSub.subscribe', lodash_1.default.noop), unsubscribe: lodash_1.default.get(WixSDKOriginal, 'PubSub.unsubscribe', lodash_1.default.noop) }), Settings: tslib_1.__assign(tslib_1.__assign({}, WixSDKOriginal.Settings), { setExternalId: function (id) {
                    return new Promise(function (resolve, reject) {
                        return WixSDKOriginal.Settings.setExternalId(id, resolve, reject);
                    });
                }, getSiteInfo: function () {
                    var viewMode = WixSDKOriginal.Utils.getViewMode();
                    if (viewMode === view_modes_1.VIEW_MODES.STANDALONE ||
                        viewMode === view_modes_1.VIEW_MODES.DASHBOARD) {
                        return Promise.resolve({
                            url: window.location.href,
                        });
                    }
                    return new Promise(WixSDKOriginal.Settings.getSiteInfo);
                }, getDashboardAppUrl: function () {
                    return new Promise(WixSDKOriginal.Settings.getDashboardAppUrl);
                } }), Styles: tslib_1.__assign(tslib_1.__assign({}, WixSDKOriginal.Styles), { setWidgetChannel: function () {
                    return lodash_1.default.noop();
                }, setFontParam: function (key, value) {
                    if (key === 'channelId' && value) {
                        setChannelIdToPublicStore(value);
                    }
                    return new Promise(lodash_1.default.partial(WixSDKOriginal.Styles.setFontParam, key, { value: value }));
                }, setBooleanParam: function (key, value) {
                    return new Promise(lodash_1.default.partial(WixSDKOriginal.Styles.setBooleanParam, key, { value: value }));
                }, setStyleParams: function (params) {
                    var channelId = lodash_1.default.get(params, 'fonts.channelId');
                    if (channelId) {
                        setChannelIdToPublicStore(channelId);
                    }
                    return new Promise(lodash_1.default.partial(WixSDKOriginal.Styles.setStyleParams, params));
                } }), Utils: tslib_1.__assign(tslib_1.__assign({}, WixSDKOriginal.Utils), { getCompId: lodash_1.default.get(WixSDKOriginal, 'Utils.getCompId', lodash_1.default.noop), getOrigCompId: lodash_1.default.get(WixSDKOriginal, 'Utils.getOrigCompId', lodash_1.default.noop), getDeviceType: lodash_1.default.get(WixSDKOriginal, 'Utils.getDeviceType', lodash_1.default.constant(DEVICE_TYPES.DESKTOP)), getBiToken: function getBiToken() {
                    var biToken = WixSDKOriginal.Utils.getInstanceValue('biToken');
                    return biToken || getRandomGuid4();
                }, getLocale: function () {
                    // I really don't know why do we need here try/catch, but I'll leave it as it was
                    try {
                        var originalGetLocale = lodash_1.default.get(WixSDKOriginal, 'Utils.getLocale', lodash_1.default.noop);
                        var locale = originalGetLocale();
                        if (!locale || locale.length > 2) {
                            // prevent xss
                            return DEFAULT_LOCALE;
                        }
                        return lodash_1.default.includes(AVAILABLE_LOCALES, locale)
                            ? locale
                            : DEFAULT_LOCALE;
                    }
                    catch (error) {
                        return DEFAULT_LOCALE;
                    }
                }, getInstance: function () {
                    if (newInstance) {
                        return newInstance;
                    }
                    try {
                        return location.search.match(/(?:\?|&)instance=([^&]+)/)[1];
                    }
                    catch (error) {
                        return null;
                    }
                }, getInstanceId: function getInstanceId() {
                    return SDK.Utils.getInstanceValue('instanceId') || getRandomGuid4();
                }, getInstanceValue: invokeSafely(function (key) {
                    // if biToken is missing for any reason, SDK.Utils.getBiToken will generate fake one
                    if (key === 'biToken') {
                        return this.getBiToken();
                    }
                    if (key === 'appDefId') {
                        if (SDK.Utils.getViewMode() === view_modes_1.VIEW_MODES.STANDALONE) {
                            return '143314e1-0660-f409-9aa7-6ed544ff1957'; // APP_DEFINITION_ID for DEV STANDALONE
                        }
                    }
                    var result = WixSDKOriginal.Utils.getInstanceValue(key);
                    if (key === 'siteOwnerId' && !result) {
                        return WixSDKOriginal.Utils.getInstanceValue('uid');
                    }
                    return result;
                }), getMetaSiteIdFromBiToken: function () {
                    var biToken;
                    var instanceId;
                    try {
                        biToken = this.getInstanceValue('biToken');
                        instanceId = this.getInstanceId();
                    }
                    catch (error) {
                        // do nothing
                    }
                    if (biToken && instanceId) {
                        return (0, guid_1.xor)(biToken, instanceId);
                    }
                }, getMetaSiteId: function () {
                    var metaSiteId = this.getMetaSiteIdFromBiToken();
                    if (metaSiteId) {
                        return Promise.resolve(metaSiteId);
                    }
                    var viewMode = SDK.Utils.getViewMode();
                    if (viewMode === view_modes_1.VIEW_MODES.STANDALONE) {
                        return Promise.reject('Unable to get metaSiteId in standalone view mode');
                    }
                    if (viewMode === view_modes_1.VIEW_MODES.EDITOR) {
                        return SDK.Settings.getDashboardAppUrl().then(function (url) { return url.match(/\/sites\/([^/]+)/)[1]; });
                    }
                    return SDK.Dashboard.getEditorUrl().then(function (url) { return url.match(/metaSiteId=([^&]+)/)[1]; });
                }, getUid: function () {
                    try {
                        return WixSDKOriginal.Utils.getUid();
                    }
                    catch (error) { }
                    try {
                        return document.cookie
                            .match(/wixClient=([^;]+)/)[1]
                            .split('|')[6];
                    }
                    catch (error) { }
                    return null;
                }, getViewMode: lodash_1.default.get(WixSDKOriginal, 'Utils.getViewMode', lodash_1.default.noop) }) }) : null;
    return SDK;
}
exports.createSDK = createSDK;
exports.WixSDK = createSDK(global.Wix);
//# sourceMappingURL=wix-sdk.js.map